"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_id_serialiser_1 = require("./../../session/session-id-serialiser");
/**
 * Serialiser for {@link ChangeAuthorisationRolesRequest}
 */
var ChangeAuthorisationRolesRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(ChangeAuthorisationRolesRequestSerialiserClass, _super);
    function ChangeAuthorisationRolesRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link ChangeAuthorisationRolesRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link ChangeAuthorisationRolesRequest} to be written
     */
    ChangeAuthorisationRolesRequestSerialiserClass.prototype.write = function (bos, value) {
        // tslint:disable-next-line:strict-type-predicates
        if (value.sessionID === undefined || value.sessionID === null) {
            throw new Error('Session ID is null or undefined');
        }
        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
        Codec.writeCollection(bos, value.rolesToRemove, Codec.writeString);
        Codec.writeCollection(bos, value.rolesToAdd, Codec.writeString);
    };
    return ChangeAuthorisationRolesRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ChangeAuthorisationRolesRequestSerialiserClass = ChangeAuthorisationRolesRequestSerialiserClass;
/**
 * The {@link ChangeAuthorisationRolesRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ChangeAuthorisationRolesRequestSerialiser = new ChangeAuthorisationRolesRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/change-authorisation-roles-request-serialiser.js
// module id = 1890
// module chunks = 1